import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


const Home = () => {
	return (
        <>
            <Row>
                <Col>
                    <p>
                        This app provides dice rolling and table lookup for Roman Seas. More functionality
                        is planned for the future, but currently, you choose which table you need, fill out
                        the drms, and the results will be displayed.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/grappling-ungrappling'>Grappling/Ungrappling</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/crew-tiring'>Crew Tiring</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/running-aground'>Running Aground</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/ramming-and-oar-rake-attacks'>Ramming & Oar Rake Attacks</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/mast-damage'>Mast Damage</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/fouling'>Fouling</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/missile-attacks'>Missile Attacks</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/artillery-hits-on-ships'>Artillery Hits on Ships</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/fire-attacks'>Fire Attacks</Button>
                </Col>
                <Col sm={12} className='pb-3 text-center'>
                    <Button variant="outline-secondary" href='/close-combat'>Close Combat</Button>
                </Col>
            </Row>
        </>
	);
};

export default Home;